import { Text } from '../ReceivementFreshTag.style'
import {
  AdditionalInfoLabelDivider, Container, TextLabel,
} from './TagHeaderRow.style'

interface TagHeaderRowProps {
  description: string,
  date: string,
  additionalInfo?: string,
  hasBorder?: boolean,
  separateAdditionalInfo?: boolean
}

const TagHeaderRow = (props: TagHeaderRowProps): JSX.Element => {
  const {
    description, date, additionalInfo, hasBorder, separateAdditionalInfo,
  } = props

  const resolveAdditionalInfoLayout = () => (
    separateAdditionalInfo
      ? (
        <AdditionalInfoLabelDivider>
          <Text limit={60}>{additionalInfo}</Text>
        </AdditionalInfoLabelDivider>
      )
      : <Text>{additionalInfo}</Text>
  )

  return (
    <Container hasBorder={hasBorder}>
      <TextLabel justifyAt='left'>
        <Text>{description}</Text>
      </TextLabel>
      <TextLabel justifyAt='center'>
        <Text>{date}</Text>
      </TextLabel>
      <TextLabel justifyAt='right'>
        {resolveAdditionalInfoLayout()}
      </TextLabel>
    </Container>
  )
}

export { TagHeaderRow }
